import { useMutation, useQueryClient } from '@tanstack/react-query';

import { queryKeys } from 'api/config';
import { logError } from 'lib/sentry/logError';
import { useMutationHTTPRequest } from 'shared_DEPRECATED/hooks';

export const useParticipantProfileNoteUpdateMutation = ({
  noteId,
  coachingSessionId,
}: {
  noteId: string;
  coachingSessionId: string;
}) => {
  const queryClient = useQueryClient();
  const { request } = useMutationHTTPRequest();

  return useMutation(
    ({ text, dashboardLink }: { text: string; dashboardLink: string }) => {
      return request({
        url: `/api/coach/coaching-client-notes/${noteId}/update`,
        body: { text, dashboardLink },
      });
    },
    {
      onSuccess: (coachingClientNote) => {
        if (
          queryClient.getQueryData([queryKeys.coachSession, coachingSessionId])
        ) {
          queryClient.setQueryData(
            [queryKeys.coachSession, coachingSessionId],
            (oldSession: any) =>
              oldSession && {
                ...oldSession,
                coachingClientNote,
              }
          );
        }
      },
      onError: (err) => {
        logError(err);
      },
    }
  );
};
